import * as React from "react";
import { SVGProps, memo } from "react";

const SvgCross = (props: SVGProps<SVGSVGElement>) => (
  <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.927.823A.781.781 0 0 0 .823 1.927L5.895 7 .823 12.073a.781.781 0 1 0 1.104 1.104L7 8.105l5.073 5.072a.781.781 0 1 0 1.104-1.104L8.105 7l5.072-5.073A.781.781 0 0 0 12.073.823L7 5.895 1.927.823Z"
      fill="#000"
    />
  </svg>
);

const Memo = memo(SvgCross);

export default Memo;
